import { render } from "./BottomListThemeView.vue?vue&type=template&id=19220b78&scoped=true"
import script from "./BottomListThemeView.vue?vue&type=script&lang=js"
export * from "./BottomListThemeView.vue?vue&type=script&lang=js"

import "./BottomListThemeView.vue?vue&type=style&index=0&id=19220b78&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19220b78"]])

export default __exports__